<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start" v-if="
        $store.state.pages.auth.back.length">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>

    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>GST Registered</h1>
            <span> Are you registered for GST?</span>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
          </div>
        </div>
        <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')"
          @keyup.enter="save('userForm')" class="full_page">

          <div class="buttons-group">
            <el-button @click="setGst(0)">
              No
            </el-button>
            <el-button type="blue" @click="setGst(1)">
              Yes
            </el-button>
          </div>

        </el-form>
        <div class="background-circles">
          <div class="circle circle-2"></div>
          <div class="circle circle-1"></div>
          <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  onMounted,
  inject,
} from "vue";

import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";



addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";

import {useStore} from "vuex";
import {
  useRouter,
  useRoute,

} from "vue-router";
import formHooks from "@/hooks/form/form";

import isEmpty from "lodash/isEmpty";
import SvgIcon from '@/components/Svg/SvgIcon.vue';


export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute()
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const routeName = $route.name;

    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;

    const formsDataArray = {
      userForm: {
        gst: {
          data: [{value: '0', label: 'No'}, {value: '1', label: 'Yes'}],
          value: userData.gst ? userData.gst :  0,
        },
      },
    };
    const goNext = () => {
      $store.dispatch('addAuthPageBack', $route.name);
   
        $router.push({
          name: 'onboard_travel',
          // name: 'auth_travel',
        })
      
    };
    const goBack = async() => {
      const back = await $store.dispatch("getAuthPageBack");
      $router.push({
          name: back,
      });      
    };
    const setGst = (value) => {
      formsData.userForm.gst.value = value
      save('userForm')
    };
    const save = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
            try {
              const data = getFormValues(formName);
              if(isEmpty(data) ) {
                const payload = {gst : 0}
                $store.dispatch("SAVE_USER_DATA", payload)
              } else {
                $store.dispatch("SAVE_USER_DATA", data)
              }
              goNext()
            } catch (errors) {
              checkFormValidation(formName, true);
            }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
    onMounted(() => {
      setPageClassGlobal('global_onboard_internal_page');
      setFormRefs();
    });

    const {
      checkFormValidation,

      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);
    



    return {
      setGst,
      formsData,
      checkFormValidation,
      goBack,
      save,
      userData,
      userRole,
      routeName,

    };
  },
};
</script>
